import primaryButtonHover from '../../../../../common/algorithms/primary-button-hover';

const dark = (params) => primaryButtonHover(params, false);

export default dark;
